import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';

export const ForgotPasswordPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';

  if (!email && location.state?.fromRegister) {
    navigate('/register');
    return null;
  }

  return <ForgotPasswordForm initialEmail={email} />;
};
